import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { FacebookPixelServiceService } from '../../services/facebook-pixel-service.service';
import { NgbDateCustomParserFormatter } from '../filters/dateformat'
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { isString } from 'util';

@Component({
  selector: 'app-form-finance-top',
  templateUrl: './form-finance-top.component.html',
  styleUrls: ['./form-finance-top.component.css']
})
export class FormFinanceTopComponent implements OnInit {


  params: any = {};
  minAmount: any = 6000;
  maxAmount: any = 75000;
  lead: any = {
    hireYear: '',
    type: '',
    job: '',
    birthday: {
      day: '',
      month: '',
      year: '',
    },
    expiration: {
      month: '',
      year: '',
    }
  };
  birthday;

  days: any = [];
  months: any = [
    {
      description: 'Gennaio',
      value: 1
    },
    {
      description: 'Febbraio',
      value: 2
    },
    {
      description: 'Marzo',
      value: 3
    },
    {
      description: 'Aprile',
      value: 4
    },
    {
      description: 'Maggio',
      value: 5
    },
    {
      description: 'Giugno',
      value: 6
    },
    {
      description: 'Luglio',
      value: 7
    },
    {
      description: 'Agosto',
      value: 8
    },
    {
      description: 'Settembre',
      value: 9
    },
    {
      description: 'Ottobre',
      value: 10
    },
    {
      description: 'Novembre',
      value: 11
    },
    {
      description: 'Dicembre',
      value: 12
    },
  ];
  years: any = [];
  yearsHire: any = [];
  yearsExpiration: any = [];

  lastResults: any = [];

  maxDate: NgbDateStruct = {
    day: (new Date()).getDay(),
    month: (new Date()).getMonth(),
    year: (new Date()).getFullYear() - 18
  };
  minDate: NgbDateStruct = {
    day: 1,
    month: 1,
    year: 1910
  };
  buyerFound: boolean = true;
  showSMS: boolean = false;
  showCall: boolean = false;
  leadId: string;
  searching: boolean = false;
  errors: any = [];
  nextStep = false;
  stepCount = 0;
  loading: boolean = false;
  code: string = "";
  error: boolean = false;
  editPhone: boolean = false;
  color: string = "#28a745"; // hover color #218838
  bgColor: string = this.color;
  buyer: any = {};
  oldBuyers: any = [];


  jobs: any;

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private api: ApiService,
    private calendar: NgbCalendar,
    private fb: FacebookPixelServiceService
  ) { }

  ngOnInit() {


    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.lead.affiliate = this.params.aff_id;
      this.lead.host = this.params.host;
      this.lead.aff_ref = this.params.aff_ref;
      this.lead.url = this.params.url;
      this.lead.type = "cessione-top";

      if (this.params.btn_color) {
        this.color = this.params.btn_color;
        this.bgColor = this.params.btn_color;
      }

      for (let i = 1; i <= 31; i++) {
        this.days.push({ value: i, description: i });
      }

      for (let i = 1900; i <= this.maxDate.year; i++) {
        this.years.push({ value: i, description: i });
      }
      this.years.reverse();


      let date = new Date;
      let year = date.getFullYear();
      for (let i = year; i <= year + 10; i++) {
        this.yearsExpiration.push({ value: i, description: i });
      }

      for (let i = 1960; i <= year; i++) {
        this.yearsHire.push({ value: i, description: i });
      }
      this.yearsHire.reverse();


      try {
        if (localStorage.getItem('el_oldBuyers')) {
          this.oldBuyers = JSON.parse(localStorage.getItem('el_oldBuyers'));
        }


        if (localStorage.getItem('userFinance')) {
          const lead = JSON.parse(localStorage.getItem('userFinance'));

          if (lead.owner !== 'eleads') {
            this.oldBuyers.push(lead.owner);
          }
        }
      } catch (e) {
        console.error(e)
      }

      this.setupJobs();

    });


    this.cd.detectChanges();
  }

  setupJobs() {

    this.jobs = [
      { id: 4, description: 'In cerca di occupazione', value: 'disoccupato' },
      { id: 4, description: 'Dipendente cooperativa', value: 'cooperativa' },
      { id: 2, description: 'Dipendente parastatale', value: 'parastatale' },
      { id: 1, description: 'Dipendente pubblico', value: 'pubblico' },
      { id: 5, description: 'Dipendente SPA', value: 'spa' },
      { id: 6, description: 'Dipendente SRL', value: 'srl' },
      { id: 0, description: 'Dipendente statale', value: 'statale' },
      { id: 3, description: 'Lavoratore autonomo', value: 'autonomo' },
      { id: 3, description: 'Militare', value: 'militare' },
      { id: 7, description: 'Pensionato', value: 'pensionato' },
      { id: 7, description: 'Altro', value: 'altro' },
    ];


  }


  check(property) {

    let amount = (isString(this.lead.amount)) ? parseInt(this.lead.amount.replace(/\./g, "")) : this.lead.amount;

    switch (property) {
      case 'gender':

        if (this.lead.gender) {
          this.errors['gender'] = false;
        } else {
          this.errors['gender'] = true;
        }

        break;

      case 'type':

        if (this.lead.type !== '') {
          this.errors['type'] = false;
        } else {
          this.errors['type'] = true;
        }

        break;

      case 'job':
        if (this.lead.job) {
          this.errors['job'] = false;

          this.lead.job_info = '';
          this.lead.layoff = (this.lead.type === "cessione") ? undefined : this.lead.layoff;
          if (this.lead.job && this.lead.zip && this.lead.type) {
          }
        } else {
          this.errors['job'] = true;
        }



        break;

      case 'segnalato':

        if (this.lead.segnalato !== undefined) {
          this.errors['segnalato'] = false;
        } else {
          this.errors['segnalato'] = true;
        }

        break;


      case 'layoff':

        if (this.lead.layoff !== undefined) {
          this.errors['layoff'] = false;

          if (this.lead.job && this.lead.zip && this.lead.type) {
          }

        } else {
          this.errors['layoff'] = true;
        }


        break;

      case 'closedCQ':

        if (this.lead.closedCQ !== undefined) {
          this.errors['closedCQ'] = false;

          if (this.lead.job && this.lead.zip && this.lead.type) {
          }

        } else {
          this.errors['closedCQ'] = true;
        }


        break;

      case 'job_info':
        let needInfo = [
          'cooperativa',
          'srl',
          'spa',
          'pensionato',
          "ditta",
          "professionista"
        ]

        if (needInfo.includes(this.lead.job)) {
          if (this.lead.job_info) {
            this.errors['job_info'] = false;

            if (this.lead.job && this.lead.zip && this.lead.type) {
            }
          } else {
            this.errors['job_info'] = true;
          }
        }


        break;


      case 'amount':

        if (amount >= this.minAmount && amount <= this.maxAmount) {
          this.errors['amount'] = false;
        } else {
          this.errors['amount'] = true;
        }

        break;



      case 'name':

        if (this.lead.name.length >= 2) {
          this.errors['name'] = false;
        } else {
          this.errors['name'] = true;
        }

        break;

      case 'surname':

        if (this.lead.surname.length >= 2) {
          this.errors['surname'] = false;
        } else {
          this.errors['surname'] = true;
        }

        break;

      case 'birthday':

        const maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((this.lead.birthday.year >= 1900 && this.lead.birthday.year < this.maxDate.year) && (this.lead.birthday.month > 0 && this.lead.birthday.month <= 12) && (this.lead.birthday.day > 0 && this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1])) {
          this.errors['birthday'] = false;
        } else {
          this.errors['birthday'] = true;
        }


        break;

      case 'email':
        this.errors['email'] = this.eleads_validate_email(this.lead.email)
        break;

      case 'vatNumber':
        this.errors['vatNumber'] = this.eleads_validate_vatNumber(this.lead.vatNumber)
        break;

      case 'phone':
        this.errors['phone'] = this.eleads_validate_phone(this.lead.phone)
        break;

      case 'zip':

        if (this.lead.zip.name && this.lead.zip.zipcode) {
          this.errors['zip'] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.zip = this.lastResults[0];
          this.errors['zip'] = false;
        } else {
          this.errors['zip'] = true;
        }

        break;



      case "numberCQ":
        if (this.lead.numberCQ >= 0) {
          this.errors['numberCQ'] = false;
        } else {
          this.errors['numberCQ'] = true;
        }
        break;

      case "expiration":

        if (this.lead.expiration.year != "" && this.lead.expiration.month != "") {
          this.errors['expiration'] = false;
        } else {
          this.errors['expiration'] = true;
        }

        break;

      case "hireYear":

        if (this.lead.job != "pensionato") {

          if (this.lead.hireYear != "") {
            this.errors['hireYear'] = false;
          } else {
            this.errors['hireYear'] = true;
          }
        }

        break;


      case 'hometown':
        if (this.lead.hometown.name && this.lead.hometown.zipcode) {
          this.errors['hometown'] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.hometown = this.lastResults[0];
          this.errors['hometown'] = false;
        } else {
          this.errors['hometown'] = true;
        }
        break;

      default:
        if (this.lead[property] !== '') {
          this.errors[property] = false;
        } else {
          this.errors[property] = true;
        }
        break;
    }

  }

  async getSetup() {
    this.loading = true;
    try {
      let data = await this.api.setupFinanceTop(this.lead)

      this.buyer = data;
      this.lead.owner = this.buyer.id;
      this.lead.needToQualify = data.needToQualify;
      this.lead.needToVerify = data.needToVerify;
      this.buyerFound = true;

      if (data.blocked) {
        this.lead.affiliate = "";
      }

      this.loading = false;
    } catch (error) {
      this.buyerFound = false;
    }
  }

  formatMatches = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInput = (value: any) => value.zipcode || '';
  selectedItem(item) {
    this.lead.city = item.item.name;
    this.errors['zip'] = false;
  };


  formatMatchesHometown = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInputHometown = (value: any) => value.zipcode || '';
  selectedItemHometown(item) {
    this.lead.hometown = item.item.name;
    this.errors['hometown'] = false;
  };

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )

  searchHometown = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )



  eleads_validate_vatNumber(vatNumber) {
    vatNumber = vatNumber.replace(/ /g, "");
    var re = /^[0-9]{11}$/;
    return !re.test(String(vatNumber).toLowerCase());
  }

  eleads_validate_email(email) {
    email = email.replace(/ /g, "");
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
  }

  eleads_validate_phone(phone) {
    phone = phone.replace(/ /g, "");
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    return !re.test(String(phone).toLowerCase());
  }

  eleads_validate_cap(cap) {
    var re = /^[0-9]{5}$/;
    return !re.test(String(cap).toLowerCase());
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verifyFinance(this.leadId, code).subscribe(
      success => {
        this.loading = false;
        this.stepCount++;
        this.oldBuyers.push(this.buyer.id)

        let sold = true;

        if (this.buyer.id === "eleads") {
          sold = false;
        } else {
          localStorage.setItem("el_oldBuyers", JSON.stringify(this.oldBuyers));
        }

        window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
      },
      error => {
        this.loading = false;
        this.error = true;
      });
  }

  next() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    let amount = (isString(this.lead.amount)) ? parseInt(this.lead.amount.replace(/\./g, "")) : this.lead.amount;
    var goOn = true;
    switch (this.stepCount) {

      case 0:
        let needInfo = [
          'cooperativa',
          'srl',
          'spa',
          'pensionato',
          "ditta",
          "professionista"
        ]


        let needContract = [
          'cooperativa',
          'srl',
          'spa',
          "statale",
          "pubblico",
          "parastatale",
          "militare",
          "altro"
        ]

        let needLayoff = [
          'cooperativa',
          'srl',
          'spa'
        ]

        if (amount >= this.minAmount && amount <= this.maxAmount) {
          this.errors['amount'] = false;
        } else {
          goOn = false;
          this.errors['amount'] = true;
        }

        if (this.lead.type == '') {
          goOn = false;
          this.errors['type'] = true;
        } else {
          this.errors['type'] = false;
        }

        if (this.lead.job == '') {
          goOn = false;
          this.errors['job'] = true;
        } else {
          this.errors['job'] = false;
        }

        if (needInfo.includes(this.lead.job)) {
          if (!this.lead.job_info) {
            this.errors['job_info'] = true;
            goOn = false;
          } else {
            this.errors['job_info'] = false;
          }
        } else {
          this.errors['job_info'] = true;
        }


        if (needLayoff.includes(this.lead.job)) {
          if (this.lead.layoff !== undefined) {
            this.errors['layoff'] = false;
          } else {
            this.errors['layoff'] = true;
            goOn = false;
          }
        }


        if (needContract.includes(this.lead.job)) {
          if (this.lead.contract !== undefined) {
            this.errors['contract'] = false;
          } else {
            this.errors['contract'] = true;
            goOn = false;
          }
        } else {
          this.lead.contract = "indeterminato"
        }





        if (this.lead.job != "pensionato") {
          if (this.lead.hireYear != '') {
            this.errors['hireYear'] = false;
          } else {
            this.errors['hireYear'] = true;
            goOn = false;
          }
        }

        if (goOn) {
          this.lead.amount = amount;
          this.stepCount++;

          window.scrollTo(0, 0);
        }
        break;

      case 1:

        if (!this.lead.gender) {
          goOn = false;
          this.errors['gender'] = true;
        } else {
          this.errors['gender'] = false;
        }

        if (!this.lead.name || this.errors['name']) {
          goOn = false;
          this.errors['name'] = true;
        } else {
          this.errors['name'] = false;
        }

        if (!this.lead.surname || this.errors['surname']) {
          goOn = false;
          this.errors['surname'] = true;
        } else {
          this.errors['surname'] = false;
        }

        var maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((this.lead.birthday.year >= 1900 && this.lead.birthday.year < this.maxDate.year) && (this.lead.birthday.month > 0 && this.lead.birthday.month <= 12) && (this.lead.birthday.day > 0 && this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1])) {
          this.errors['birthday'] = false;
        } else {
          this.errors['birthday'] = true;
          goOn = false
        }


        if (!this.lead.zip || this.errors['zip']) {
          goOn = false;
          this.errors['zip'] = true;
        } else {
          this.errors['zip'] = false;
        }




        if (goOn) {
          this.getSetup().then(() => {
            this.stepCount++;

          })
          this.fb.track("step_2");
          window.scrollTo(0, 0);
        }
        break;

      case 2:


        if (!this.lead.phone || this.errors['phone']) {
          goOn = false;
          this.errors['phone'] = true;
        } else {
          this.errors['phone'] = false;
        }

        if (!this.lead.email || this.errors['email']) {
          goOn = false;
          this.errors['email'] = true;
        } else {
          this.errors['email'] = false;
        }

        if (this.buyer.id == "eleads") {
          if (!this.lead.privacy_data) {
            goOn = false;
            this.errors['privacy_data'] = true;
          } else {
            this.errors['privacy_data'] = false;
          }
        } else {

          this.buyer.privacies.map(privacy => {
            if (privacy.required) {
              if (!this.lead[privacy.paramName]) {
                goOn = false;
                this.errors[privacy.paramName] = true;
              } else {
                this.errors[privacy.paramName] = false;
              }
            }
          })

        }

        if (this.lead.job_info === "meno15" || this.lead.job_info === "meno50") {

          if (this.lead.segnalato !== undefined) {
            this.errors['segnalato'] = false;
          } else {
            this.errors['segnalato'] = true;
            goOn = false;
          }

        }



        if (goOn) {
          this.loading = true;
          var lead = this.lead;
          lead.cap = lead.zip.zipcode;
          this.api.postLeadFinance(this.lead).subscribe(
            (id: any) => {

              if (this.lead.needToVerify) {
                this.leadId = id.id;
                this.stepCount++;
                this.loading = false;
                this.api.sendSMSFinance(this.leadId).subscribe();
                window.parent.postMessage({ sender: 'e-leads', message: "verify", id: this.leadId }, '*');
              } else {
                this.leadId = id.id;
                this.stepCount += 2;
                this.loading = false;
                let sold = (this.buyer.id !== "eleads") ? true : false;
                window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
              }

              this.fb.track("form_compilato");

              window.scrollTo(0, 0);
            }, error => {
              this.loading = false;
              this.error = true;
              window.scrollTo(0, 0);
            }
          )
        }
        break;

      case 4:

        break;

      default:
        break;
    }




  }


  sendSMS() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneFinance(this.leadId, phone)
      .subscribe(success => {
        this.api.sendSMSFinance(this.leadId).subscribe(
          success => {
            this.showSMS = true;
          },
          error => {
            this.error = true;
          });
      });
  }

  sendCall() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneFinance(this.leadId, phone)
      .subscribe(success => {
        this.api.sendCallFinance(this.leadId)
          .subscribe(
            success => {
              this.showCall = true;
            },
            error => {
              this.error = true;
            });
      }, error => {
        this.error = true;
      });
  }

  prev() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    this.stepCount--;
  }

  checkData(step) {
    var goOn = false;
    switch (step) {
      case 0:

        break;
    }

  }


  registerClick() {
    this.api.registerClick(this.leadId, this.buyer.id).subscribe()
  }

  mouseEnter() {
    var rgb = this.hexToRgb(this.color);

    // create a darker shade for hover effect
    rgb.r *= 0.8;
    rgb.g *= 0.8;
    rgb.b *= 0.8;

    this.bgColor = this.rgbToHex(rgb.r, rgb.g, rgb.b);
  }

  mouseLeave() {
    this.bgColor = this.color;
  }

  //-------------------------------- FUNCTION TO TRANSFORM HEX COLOR TO RGB AND BACK

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  rgbToHex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1)
  }

  public onFocusSelect(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }


}
